export default __webpack_public_path__ + "static/media/Screen Shot 2021-10-26 at 9.07.41 PM-removebg-preview-removebg-preview (2).25db2929.jpg";